import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';

import { TextButtonSto } from 'components/sto';

import ContactModal from '../modals/ContactModal';
import OTPResentModal from '../modals/OTPResentModal';

import ValidateUserForm from './ValidateUserForm';

function ValidateUserContent(props) {
    const [displayModal, updateModalVisibility] = useState(false);
    const [otpSent, isOTPSent] = useState(true);
    const [displayContactModal, updateContactModalVisibility] = useState(false);

    const onModalClosing = () => {
        updateModalVisibility(false);
    };

    const resendCode = () => {
        Auth.resendSignUp(props.username)
            .then(() => {
                updateModalVisibility(true);
                isOTPSent(true);
            })
            .catch(() => {
                updateModalVisibility(true);
                isOTPSent(false);
            });
    };

    return (
        <React.Fragment>
            <div className="wrapper-message pprlpay-page-primary-content">
                <div>
                    <div className="wrapper-button-sto-container">
                        <ValidateUserForm email={props.email} username={props.username} />
                        <p className="resend-code-text">
                            <FormattedMessage id="pages.forgotPassword.resendCode" />
                        </p>
                        <TextButtonSto
                            className="button-link sto-links"
                            id="page-registration-verifyAccount-button-resendCode"
                            labelKey="pages.forgotPassword.resendCodeLink"
                            onClick={resendCode}
                        />

                        <div className="pprlpay-link-container mobile-only">
                            <p>
                                <FormattedMessage id="pages.registration.links.contactus.title" />
                            </p>
                            <TextButtonSto
                                className="button-link sto-links"
                                id="page-registration-createUser-button-contactUs"
                                labelKey="pages.registration.links.contactus.text"
                                onClick={() => updateContactModalVisibility(true)}
                                type="button"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="pprlpay-page-secondary-content desktop-only">
                <div className="pprlpay-link-container">
                    <p>
                        <FormattedMessage id="pages.registration.links.contactus.title" />
                    </p>
                    <TextButtonSto
                        className="button-link sto-links"
                        id="page-registration-aboutYou-button-contactUs"
                        labelKey="pages.registration.links.contactus.text"
                        onClick={() => updateContactModalVisibility(true)}
                        type="button"
                    />
                </div>
            </div>

            <ContactModal onOk={() => updateContactModalVisibility(false)} visible={displayContactModal} />
            <div>
                <OTPResentModal email={props.email} onOk={onModalClosing} otpSent={otpSent} visible={displayModal} />
            </div>
        </React.Fragment>
    );
}
ValidateUserContent.propTypes = {
    email: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
};
export default injectIntl(ValidateUserContent);
